import TextChartTitle from '@components/text/TextChartTitle'
import { IclassifiedNewAndOldCustomerByYear } from '@interfaces/api/IDashboard'
import React from 'react'
import Chart from 'react-google-charts'
import ChartFlexSection from './ChartFlexSection'
import { ColumnChartOptions } from './setting'

interface IAgenciesAmountISOColumnChart {
  title: string
  data: IclassifiedNewAndOldCustomerByYear
}

const AgenciesAmountISOColumnChart = ({ title, data }: IAgenciesAmountISOColumnChart) => {
  const typeName = 'ปีงบประมาณ'
  const valueName = 'จำนวนหน่วยงาน'
  const groupedData = Object.keys(data)

  const prepareDatawithAnnotation = groupedData.map((Byear, index) => {
    const old_agency = data[Byear].oldcustomer.length
    const new_agency = data[Byear].newcustomer.length
    return [`ปีงบประมาณ ${Number(Byear) + 543}`, old_agency, old_agency, new_agency, new_agency]
  })
  const columnChartData = [
    ['ปีงบประมาณ', 'ลูกค้าเก่า', { role: 'annotation' }, 'ลูกค้าใหม่', { role: 'annotation' }],
    ...prepareDatawithAnnotation,
  ]

  const options = ColumnChartOptions(valueName, typeName)
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Chart
        width={'100%'}
        height={'500px'}
        chartType="ColumnChart"
        loader={<div>Loading Chart</div>}
        data={columnChartData}
        options={options}
      />
    </ChartFlexSection>
  )
}

export default AgenciesAmountISOColumnChart
